import { ApiEvent } from "./event.model";

export class ApiMeeting extends ApiEvent {
    location: string;
}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/meeting.model.ts